var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.865 0 0.5 3.38833 0.5 7.55417C0.5 13.4733 7.295 19.585 7.58417 19.8417C7.70333 19.9475 7.85167 20 8 20C8.14833 20 8.29667 19.9475 8.41583 19.8425C8.705 19.585 15.5 13.4733 15.5 7.55417C15.5 3.38833 12.135 0 8 0ZM8 11.6667C5.7025 11.6667 3.83333 9.7975 3.83333 7.5C3.83333 5.2025 5.7025 3.33333 8 3.33333C10.2975 3.33333 12.1667 5.2025 12.1667 7.5C12.1667 9.7975 10.2975 11.6667 8 11.6667Z",
    fill: "#2D448D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.addb221c.svg";
export { ForwardRef as ReactComponent };